import gql from 'graphql-tag';

import referralFragment from '../fragments/referralFragment';

export const mutationUpsertReferral = gql`
  mutation upsertReferral (
    $referrerAccountID: DokkioID!
  ) {
    upsertReferral (
      referrerAccountID: $referrerAccountID
    ) {
      ...referralFragment
    }
  }
  ${referralFragment}
`;
export default mutationUpsertReferral;
